<template>
  <div>
    <div>
      <com-admin v-if="url == 0" />
      <com-student v-else-if="url == 2" />
      <com-parent v-else-if="url == 3" />
      <!-- 添加选课按钮 -->
      <div class="course-button-container">
        <el-button
          type="primary"
          icon="el-icon-reading"
          @click="goToCourse"
          size="medium"
          round>
          选课中心
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import comAdmin from './rolePage/adminAndTeacher.vue'
import comStudent from './rolePage/student.vue'
import comParent from './rolePage/parent.vue'
export default {
  components: {
    comAdmin,
    comStudent,
    comParent
  },
  data() {
    return {
      url: 0
    }
  },
  created() {
    // 确保主页侧边栏显示
    this.$store.dispatch('app/openSideBar', { withoutAnimation: false })

    // 判断角色
    const roles = localStorage.getItem('roles')
    console.log('roles:', roles)
    switch (roles) {
      case 'admin': {
        this.url = 0
        break
      }
      case 'teacher': {
        this.url = 0
        break
      }
      case 'student': {
        this.url = 2
        break
      }
      case 'parent': {
        this.url = 3
        break
      }
    }
  },
  methods: {
    goToCourse() {
      this.$router.push('/course/selection')
    }
  }
}
</script>
<style scoped>
/* 添加按钮样式 */
.course-button-container {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 1000;
}

.course-button-container .el-button {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
}

.course-button-container .el-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.2);
}
</style>
